export default {
  INDIVIDUAL_EXTRA_ALERT: {
    LIMITED_INVENTORY: 'LIMITED_INVENTORY',
    RECOMMENDED: 'RECOMMENDED',
  },
};
